// extracted by mini-css-extract-plugin
export var button = "index-module--button--DVTj8";
export var buttonContainer = "index-module--buttonContainer--MqbCJ";
export var footer = "index-module--footer--uojx8";
export var footerIntro = "index-module--footerIntro--LkODG";
export var footerMain = "index-module--footerMain--Z6Shy";
export var logo = "index-module--logo--NayvD";
export var pcContainer = "index-module--pcContainer--zvA6W";